module.exports = __webpack_public_path__ + "static/media/nav-dashboard.0a5cf45c.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Header/nav-dashboard.svg
 ** module id = 1312
 ** module chunks = 0
 **/